import './DetailsTable.scss';
import ChangeRecords from './ChangeRecord';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailsExportButton } from './DetailsExportButton';
import { getTimelineDetailColumns } from './DetailsTableColumns';
import { isRowExpandable } from './@arch/lib';
import { SonarCard } from '@ui/general';
import { getTimelineDetailsSelector, getTimelineSummarySelector } from './@arch/selectors';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { PaginatedTable } from '@ui/tables';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { usePeriscopeActions, usePrevious, useSonarSelector } from '@hooks';
const tableColumns = getTimelineDetailColumns();
const renderChangeRecords = (record) => React.createElement(ChangeRecords, { record: record });
const renderRowKey = (record) => record.change.id;
export const TimelineDetailsTable = ({ params, onChange }) => {
    var _a;
    const summary = useSonarSelector(getTimelineSummarySelector.data);
    const disabled = !Object.keys((_a = summary === null || summary === void 0 ? void 0 : summary.changeCounts) !== null && _a !== void 0 ? _a : {}).length;
    const { openPeriscope } = usePeriscopeActions();
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const previousParams = usePrevious(params);
    const resource = useSonarSelector(getTimelineDetailsSelector.data);
    const areDetailsLoading = useSonarSelector(getTimelineDetailsSelector.isRequested);
    const onExpandedRowsChange = useCallback((keys) => setExpandedRowKeys([...keys]), []);
    const onRowClick = useCallback((record) => {
        var _a;
        if (record.isVanished || record.sonarObjectType === SonarObjectType.SalesforceProfile) {
            return;
        }
        openPeriscope({
            id: record.sonarObjectId,
            name: (_a = record.displayName) !== null && _a !== void 0 ? _a : '',
            openedFromIndex: -1,
            type: record.sonarObjectType
        });
    }, [openPeriscope]);
    const columns = useMemo(() => tableColumns.map((column) => (Object.assign(Object.assign({}, column), { sorter: !disabled }))), [disabled]);
    useEffect(() => {
        if (params !== previousParams) {
            setExpandedRowKeys([]);
        }
    }, [previousParams, params]);
    return (React.createElement(SonarCard, { bordered: false, extra: React.createElement(DetailsExportButton, { disabled: disabled, queryParams: params }), id: 'timeline-details', loading: !resource, noSpacing: true, title: COPY_SPECIFIC.DETAILED_LIST_OF_CHANGES },
        React.createElement(PaginatedTable, { columns: columns, expandable: {
                expandedRowKeys: expandedRowKeys,
                expandedRowRender: renderChangeRecords,
                onExpandedRowsChange: onExpandedRowsChange,
                rowExpandable: isRowExpandable
            }, loading: areDetailsLoading, onChange: onChange, onRow: (record) => ({
                className: record.isVanished || record.sonarObjectType === SonarObjectType.SalesforceProfile ?
                    '' :
                    'clickable',
                onClick: () => onRowClick(record)
            }), resource: resource, rowKey: renderRowKey })));
};
